<template>
  <div class="chart-one">
    <div class="box">
      <h1>新型攻击方法</h1>
      <div class="text">
        <p>
            {{content}}
        </p>
      </div>


    </div>
  </div>
</template>
<style scoped lang="less">
.chart-one {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
}
.box {
  position: relative;
  color: rgba(255, 255, 255, 1);
}
h1{
  color: rgba(241, 237, 255, 1);
  font-family: 'YouSheBiaoTiHei';
  font-size: 24px;
  height: 31px;
  position: absolute;
  left: 36px;
  top: 15px;
  text-shadow: 0 2px 20px rgba(42, 56, 180, 1) ;
}
.text{
  position: absolute;
  left: 30px;
  top: 55px;
  width: 390px;
  height: 275px;
  padding: 30px 30px;
  box-sizing: border-box;
  background: url("../../assets/newTheatre/textbackground.png") no-repeat;
  background-size: 100%;
  p{
    height: 120px;
    overflow: scroll;
    overflow-x: hidden;
    font-family: AlibabaRegular;
    font-size: 14px;
    padding-right: 30px;
    text-align: left;
    word-break: break-all;
  }
}

// 水平方向滚动条
p::-webkit-scrollbar {
  //修改滚动条宽度或高度
  width: 7px;
  //border-radius: 8px;
}
p::-webkit-scrollbar-thumb {
  //border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  background: linear-gradient(#949EE8,#8F9AF4);
  border: 1px solid transparent;
  border-image:linear-gradient(rgb(255, 255, 255), rgba(255,255,255,0.1)) 1;
}
p::-webkit-scrollbar-track {
  //-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  //background: rgba(241, 237, 255, 1);
}

</style>
<script>
import {getVulnerabilityDescription} from "@/service/dashboard";
import store from "@/store";
export default {
  data() {
    return {
      content: ""
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      getVulnerabilityDescription().then(res => {
        if (res[store.state.dict.threatId]) {
          this.content = res[store.state.dict.threatId];
        }
      });
    }
  }
};
</script>